import {Terms} from '../components/TermsComponent';

export const complianceWithLaws: Terms = [
  {
    id: '12.1',
    term:
      'You shall comply with all applicable laws, statues, ordinances and regulations pertaining to your use of and access to this Website.',
  },
];
